import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './styles/normalize.css';
import './styles/global.css';

import {
  GlobalStyle,
  BtnCircle,
  DefaultKineduLogo,
  LanguageButton,
  Languages,
  Left,
  Navbar,
  Right,
  Row,
  View,
  ViewContainer,
  WhiteKineduLogo,
} from './styles';

import i18n from 'i18n';
import { useParams } from 'react-router-dom';

const Layout = ({ children }) => {
  const { lang } = useParams();

  const currentLang = localStorage.i18nextLng;

  const selectedLang = (value) => {
    i18n.changeLanguage(value);
  };

  useMemo(() => {
    if (lang) {
      selectedLang(lang);
    }
  }, [lang]);

  return (
    <>
      <GlobalStyle />
      <main>
        <View>
          <Left />
          <Right />
          <ViewContainer>
            <Navbar>
              <WhiteKineduLogo lang={currentLang} />
              <DefaultKineduLogo lang={currentLang} />
              <Languages>
                <LanguageButton onClick={() => selectedLang('es')}>
                  <BtnCircle selected={currentLang === 'es'}>ES</BtnCircle>
                </LanguageButton>
                <LanguageButton onClick={() => selectedLang('en')}>
                  <BtnCircle selected={currentLang === 'en'}>EN</BtnCircle>
                </LanguageButton>
                <LanguageButton onClick={() => selectedLang('pt')}>
                  <BtnCircle selected={currentLang === 'pt'}>PT</BtnCircle>
                </LanguageButton>
              </Languages>
            </Navbar>
            <Row>{children}</Row>
          </ViewContainer>
        </View>
      </main>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
